module.exports = __webpack_public_path__ + "img/IT0001052422427.bffba575.png";